import { createApp } from "vue";
import "@syjy/base/configure";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { checkDeviceAndRedirect } from "@/utils";

window.__VUE_PROD_DEVTOOLS__ = false;
window.__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;

process.env.NODE_ENV === "production" && checkDeviceAndRedirect();

createApp(App).use(store).use(router).mount("#app");
